module.exports = __webpack_public_path__ + "img/leaf-sample.639c1b1f.png";